import 'angular';
import Features from '../feature-manager/Features';
import { RootScope } from '../types/angular-types';
import AppConstants from '../gorillaboy/AppConstants';
import {VersionMetadata} from '../types/DocMetadata'

interface NativeRenderingUtils {    
    isAudioOrVideoContent: (mimeType: string) => boolean;
    isNativeRenderingSupported: (documentVersion: VersionMetadata) => boolean;
}

function NativeRenderingUtilsFactory () {
    
    const service: NativeRenderingUtils = {
        isAudioOrVideoContent: (mimeType: string) => {
            return ['audio/mp3', 'audio/mpeg', 'video/mpeg', 'video/mp4', 'audio/mp4', 'application/mp4', 'video/quicktime', 'video/webm', 'video/ogg'].indexOf(mimeType) !== -1;
        },
        isNativeRenderingSupported: function(documentVersion) {
            return service.isAudioOrVideoContent(documentVersion.ContentType);
        }
    };

    return service;    
}


NativeRenderingUtilsFactory.$inject = [];

function NativeRendererFactory(DocumentService, $rootScope: RootScope, $sce: ng.ISCEService, $timeout: ng.ITimeoutService) {
    return {
        scope: {
            documentId: '<',
            versionId: '<',
            documentPasscode: '<',
            isAnonymous: '<'
        },
        template: `
            <div class="native-renderer-wrapper">
                <div ng-if="!downloadComplete">
                    <div class="progress-indicator"></div>
                </div>
                <div ng-if="downloadFailed">
                    <p>{{'GENERAL_MESSAGES.ERROR_FETCHING_CONTENT'|translate}}</p> 
                </div>
                <video ng-if="downloadComplete && !downloadFailed" ng-attr-src="{{contentUrl}}" controls>
                  <p>{{'NATIVE_RENDERING.BROWSER_NOT_SUPPORT_HTML5_AUDIO_VIDEO'|translate}}</p> 
                </video>
            </div>
        `,
        link: function NativeRendererLinkFunction($scope, $element, $attrs) {            
            var currentRetryNo = 0;
            const MAX_RETRIES_FOR_FETCHING_CONTENT_URL = 3;
            fetchContentUrl();

            function fetchContentUrl() {
                $scope.downloadComplete = false;
                $scope.downloadFailed = false;
                if (currentRetryNo++ >= MAX_RETRIES_FOR_FETCHING_CONTENT_URL) {                    
                    $scope.downloadFailed = true;
                    $scope.downloadComplete = true;
                    $rootScope.metricServiceInstance.newCounterMetric("NativeRenderer.AudioVideo.RetryError");
                    return;
                }
                DocumentService.getDocumentVersionSource($scope.documentId, $scope.versionId, 
                     $scope.documentPasscode, $scope.isAnonymous)
                .then(function(response) {                    
                    var data = response.data;
                    var source = data.Metadata.Source,
                        sourceUrl = source.ORIGINAL;
                    $scope.contentUrl = $sce.trustAsResourceUrl(sourceUrl);
                    $timeout(bindErrorCallback);                    
                }, function(response) {                
                    $scope.downloadFailed = true;                
                })
                .finally(function() {
                    $scope.downloadComplete = true;
                });    
            }           

            function bindErrorCallback() {
                var video:HTMLVideoElement = $element.find("video").get(0);
                video.addEventListener('error', (event) => {
                    $scope.$apply(function() {
                        $rootScope.metricServiceInstance.newCounterMetric("NativeRenderer.AudioVideo.Error");
                        fetchContentUrl();
                    });                  
                }, true);
                video.addEventListener('play', (event) => {
                    $scope.$apply(function() {
                        $rootScope.metricServiceInstance.newCounterMetric("NativeRenderer.AudioVideo.Play");
                    });
                }, true);
            }            
        }
    };
}
NativeRendererFactory.$inject = ['DocumentService', '$rootScope', '$sce', '$timeout'];

/**
 * This service will get messages from S3 bucket and show those on the website
 */
angular.module('GorillaBoy.DocumentViewer')
.factory('NativeRenderingUtils', NativeRenderingUtilsFactory);


angular.module('GorillaBoy.DocumentViewer')
.directive('nativeRenderer', NativeRendererFactory);

export {
    NativeRenderingUtils
};
